<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SeaExport.CopyFromOtherBill')"
      width="1000px"
      :close-on-click-modal="false"
      append-to-body
      class="app-main-inner edi-bill-search-selector"
      @close="cancel()"
    >
      <div class="app-main-inner-row">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_BusinessNo')">
            <el-input v-model="jobNo" style="width: 260px;" no="1" />
            <el-button style="margin-left: 30px;" type="primary" no="2" @click="searchHandler">{{ $t('common.btn.query') }}</el-button>
          </el-form-item>
          <el-form-item />
        </el-form>
      </div>
      <div class="app-main-inner-row row-grid" style="min-height:350px;padding:0">
        <cargo-ag-grid
          config-module="130202"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDef"
          :row-data="rowData"
          style="width:100%;height:350px;"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
      <div class="app-main-inner-row row-pagination">
        <cargo-pagination
          v-show="searchConditions.total>0"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="searchHandler"
        />
      </div>
      <div slot="footer">
        <el-button type="primary" no="3" @click="confirm">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="4" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { searchCargoDoc } from '@/api/seaExport/cargoDoc'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'CopyFromOtherBillDialog',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    docType: { type: String, default: '' },
    lob: { type: String, default: '' }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      jobNo: '',
      innerVisible: false,
      searchConditions: {
        pageNum: 1,
        pageSize: 20,
        total: 0
      },
      rowData: [],
      columnDef: [
        { headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', width: 200 },
        {
          headerName: 'Shipper',
          field: 'shipperLine',
          width: 300,
          cellRenderer: this.multipleDataRellRenderer
        },
        {
          headerName: 'Consignee',
          field: 'consigneeLine',
          width: 300,
          cellRenderer: this.multipleDataRellRenderer
        },
        {
          headerName: 'Notify',
          field: 'notifyLine',
          width: 300,
          cellRenderer: this.multipleDataRellRenderer
        }
      ],
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: false,
        onCellFocused: event => {
          this.selectedRowIndex = event.rowIndex
        },
        rowHeight: 150
      },
      selectedRowIndex: -1
    }
  },
  computed: {
    selectedRow() {
      return this.rowData[this.selectedRowIndex]
    }
  },
  watch: {
    visible: {
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.init()
        }
      },
      immediate: true
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    init() {
      this.jobNo = ''
    },
    searchHandler() {
      this.gridApi.clearFocusedCell() // 清除选中行
      if (!this.jobNo || !this.jobNo.trim()) {
        this.$message.warning(this.$t('Message.PleaseInputBussinessNo'))
        return
      }
      this.loading = getLoading()
      const body = { jobNo: this.jobNo.trim(), pageSize: this.searchConditions.pageSize, pageNum: this.searchConditions.pageNum, branchId: this.$store.getters.currentOfficeId }
      if (this.docType) {
        body.docType = this.docType
      }
      if (this.lob) {
        body.lob = this.lob
      }
      searchCargoDoc(body).then(result => {
        this.rowData = []
        if (result.data.list) {
          this.rowData = result.data.list
          for (const item of this.rowData) {
            let shipperLine = ''
            let consigneeLine = ''
            let notifyLine = ''
            for (let i = 1; i < 8; ++i) {
              shipperLine += (item['shipperLine' + i] || '') + '<br/>'
              consigneeLine += (item['consigneeLine' + i] || '') + '<br/>'
              notifyLine += (item['notifyLine' + i] || '') + '<br/>'
            }
            item.shipperLine = shipperLine
            item.consigneeLine = consigneeLine
            item.notifyLine = notifyLine
          }
        }
        this.searchConditions.total = parseInt(result.data.total)
      }).catch(message => {
      }).finally(() => {
        this.loading.close()
      })
    },
    confirm() {
      if (!this.selectedRow) {
        this.$message.warning(this.$t('SeaExport.SelectARecord'))
        return
      }
      this.$emit('selected', this.selectedRow)
      this.innerVisible = false
    },
    cancel() {
      this.innerVisible = false
      this.rowData = []
      this.jobNo = ''
    },
    multipleDataRellRenderer(params) {
      if (params.value !== undefined) {
        return params.value.replace(/<br\/>/g, '<br/>')
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
  .edi-bill-search-selector {
    label {
      font-size: 12px;
      font-weight: normal;
    }
    .el-select {
      width: 100%;
    }
  }
</style>
